<template>
    <div class="Actualizaciones">
        <template v-if="existeActualizacion">
            <div class="modal fade" id="AlertaNuevaActualizacion" tabindex="-1" data-bs-backdrop="static"
                data-bs-keyboard="false" aria-labelledby="AlertaNuevaActualizacionLabel" aria-hidden="true">
                <div
                    class="modal-dialog modal-lg modal-fullscreen-sm-down modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content update-modal-content">
                        <div class="modal-header update-modal-header">
                            <h5 class="modal-title update-modal-title">
                                <i class="fas fa-rocket me-2"></i>Actualización disponible
                            </h5>
                        </div>
                        <div class="modal-body update-modal-body">
                            <div class="row gap-3">
                                <div class="col-md-12">
                                    <span class="update-section-title">
                                        Versiones
                                    </span>
                                </div>
                                <div class="col-6 col-md">
                                    <div class="update-version-label">Actual</div>
                                    <div class="update-version-value">
                                        {{ versiones.antigua ?
                                            versiones.antigua.nombre :
                                            $store.state.versiones.antigua.nombre ?
                                                $store.state.versiones.antigua.nombre :
                                                "-" }}
                                    </div>
                                </div>
                                <div class="col-6 col-md">
                                    <div class="update-version-label">Nueva</div>
                                    <div class="update-version-value text-primary font-bold">
                                        {{ versiones.nueva ?
                                            versiones.nueva.nombre :
                                            $store.state.versiones.nueva.nombre ?
                                                $store.state.versiones.nueva.nombre : "-" }}
                                    </div>
                                </div>
                                <div class="col-md-12 mt-2">
                                    <span class="update-section-title">
                                        ¿Qué contiene esta actualización?
                                    </span>
                                    <template v-if="versiones.nueva && versiones.nueva.detalles.length > 0">
                                        <div v-for="(detalle, index) of versiones.nueva.detalles"
                                            class="card update-card" :class="{ 'mt-2': index !== 0 }" :key="index">
                                            <div class="card-body update-card-body">
                                                <div class="update-card-title-row">
                                                    <span class="update-card-title">
                                                        {{ detalle.titulo }}
                                                        <span v-if="detalle.tipo" class="badge update-badge ms-2"
                                                            :class="{
                                                                'text-bg-success': detalle.tipo === 'Nueva Característica',
                                                                'text-bg-primary': detalle.tipo === 'Mejora',
                                                                'text-bg-warning text-dark': detalle.tipo === 'Rendimiento',
                                                                'text-bg-danger': detalle.tipo === 'Solución de Error',
                                                                'text-bg-dark': detalle.tipo === 'Seguridad',
                                                                'text-bg-secondary': detalle.tipo === 'Otros',
                                                            }">
                                                            {{ detalle.tipo }}
                                                        </span>
                                                    </span>
                                                </div>
                                                <p class="update-card-desc">
                                                    {{ detalle.descripcion }}
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <p class="update-empty-text">Actualizaciones necesarias.</p>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer update-modal-footer">
                            <button type="button" class="btn btn-primary btn-update-action"
                                @click="actualizarVersion()">
                                Actualizar ahora
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import localforage from "localforage";
export default {
    name: "Actualizaciones",

    data() {
        return {
            suscripcion: null,
            existeActualizacion: false,
            actualizando: false,
            versiones: {
                antigua: null,
                nueva: null
            },
            actualizacionPendiente: false,
            intervaloVerificacion: null
        };
    },

    watch: {
        $route() {
            this.intentarMostrarModal();
        },
        existeActualizacion() {
            if (this.existeActualizacion === true) {
                if (!Modal.getInstance(document.getElementById('AlertaNuevaActualizacion'))) {
                    setTimeout(() => {
                        new Modal(document.getElementById("AlertaNuevaActualizacion")).show();
                    }, 20);
                }
            } else if (this.existeActualizacion === false && Modal.getInstance(document.getElementById('AlertaNuevaActualizacion'))) {
                Modal.getInstance(document.getElementById('AlertaNuevaActualizacion')).hide();
            }
        }
    },

    created() {
        document.addEventListener(
            'serviceWorkerUpdateEvent', this.mostrarActualizacion, { once: true }
        );

        navigator.serviceWorker.addEventListener(
            'controllerchange', () => {
                if (this.actualizando) return;
                this.actualizando = true;
                window.location.reload();
            }
        );

        // Exponer función de prueba en el objeto global window para desarrollo y pruebas
        /*window.triggerTestUpdate = () => {
            console.log("Simulando detección de nueva actualización...");
            this.mostrarActualizacion({
                detail: {
                    version: this.$store.state.versiones.nueva,
                    waiting: {
                        postMessage: (msg) => {
                            console.log('Mensaje SKIP_WAITING enviado al Service Worker simulado:', msg);
                        }
                    }
                }
            });
        };*/
    },

    destroyed() {
        this.limpiarChequeoPendiente();
        /*if (window.triggerTestUpdate) {
            delete window.triggerTestUpdate;
        }*/
    },

    methods: {
        mostrarActualizacion: async function (e) {
            this.suscripcion = e.detail;
            const versiones = await localforage.getItem("riskmann_versiones");
            if (versiones) {
                this.versiones.antigua = versiones.nueva;
            }
            this.versiones.nueva = e.detail.version;
            this.actualizacionPendiente = true;
            this.intentarMostrarModal();
        },

        intentarMostrarModal() {
            if (!this.actualizacionPendiente) return;

            // Rutas de autenticación o entrada donde no deseamos interrumpir
            const rutasExcluidas = ['Entrada', 'Login', 'Registrarse', 'RedirectTo'];
            const rutaActual = this.$route ? this.$route.name : '';

            if (rutasExcluidas.includes(rutaActual)) {
                console.log("Actualización pendiente: esperando a salir de la pantalla de entrada...");
                this.iniciarChequeoPendiente();
                return;
            }

            // Verificar si hay algún modal de Bootstrap o SweetAlert activo
            const hayModalAbierto = !!document.querySelector('.modal.show:not(#AlertaNuevaActualizacion)');
            const haySwalAbierto = !!document.querySelector('.swal2-container');

            if (hayModalAbierto || haySwalAbierto) {
                console.log("Actualización pendiente: esperando que se cierren otros modales o alertas...");
                this.iniciarChequeoPendiente();
                return;
            }

            // Si la pantalla está despejada y la ruta es válida, mostramos la alerta de actualización
            this.limpiarChequeoPendiente();
            this.actualizacionPendiente = false;
            this.existeActualizacion = true;
        },

        iniciarChequeoPendiente() {
            if (!this.intervaloVerificacion) {
                this.intervaloVerificacion = setInterval(() => {
                    this.intentarMostrarModal();
                }, 2000); // Reintentar cada 2 segundos
            }
        },

        limpiarChequeoPendiente() {
            if (this.intervaloVerificacion) {
                clearInterval(this.intervaloVerificacion);
                this.intervaloVerificacion = null;
            }
        },

        async actualizarVersion() {
            this.existeActualizacion = false;
            if (this.suscripcion && this.suscripcion.waiting) {
                this.suscripcion.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
            await localforage.setItem("riskmann_versiones", this.versiones);
        },
    }
}
</script>

<style scoped>
.update-modal-content {
    border-radius: 12px;
    border: none;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.update-modal-header {
    background-color: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    padding: 1rem 1.5rem;
}

.update-modal-title {
    color: #073d7a;
    font-weight: 700;
    font-size: 1.2rem;
    margin: 0;
}

.update-modal-body {
    padding: 1.5rem;
}

.update-section-title {
    display: block;
    font-size: 0.85rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #64748b;
    margin-bottom: 0.5rem;
}

.update-version-label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
}

.update-version-value {
    font-size: 1rem;
    font-weight: 700;
    color: #334155;
    margin-top: 0.25rem;
}

.update-version-value.text-primary {
    color: #073d7a !important;
}

.update-card {
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    transition: all 0.2s ease;
}

.update-card:hover {
    border-color: #cbd5e1;
    transform: translateY(-1px);
}

.update-card-body {
    padding: 0.85rem 1rem;
}

.update-card-title-row {
    margin-bottom: 0.35rem;
}

.update-card-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1e293b;
}

.update-badge {
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.25em 0.6em;
    border-radius: 4px;
}

.update-card-desc {
    font-size: 0.85rem;
    color: #475569;
    line-height: 1.45;
    margin: 0;
}

.update-empty-text {
    font-size: 0.9rem;
    color: #64748b;
    margin: 0;
}

.update-modal-footer {
    border-top: 1px solid #e2e8f0;
    background-color: #f8fafc;
    padding: 0.85rem 1.5rem;
}

.btn-update-action {
    background-color: #073d7a;
    border-color: #073d7a;
    font-size: 0.9rem;
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
    font-weight: 600;
    transition: background-color 0.2s;
}

.btn-update-action:hover {
    background-color: #052a54;
    border-color: #052a54;
}
</style>